import {Component, Input, Output, EventEmitter, AfterViewInit} from "@angular/core";
import {Funcoes} from "../../funcoes";

declare let $:any;

@Component({
  selector: 'widget-input-moeda',
  template: `<div
                [formGroup]="form"
                [class.has-error]="form.controls[id] && form.controls[id].touched && !form.controls[id].valid"
                [class.has-feedback]="form.controls[id] && form.controls[id].touched && !form.controls[id].valid">
                <label class="control-label text-right {{labelClass}}" for="{{id}}" [class.active]="model">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  <div [class.input-group]="comIcone">
                    <span class="input-group-addon" *ngIf="comIcone">{{comIcone}}</span>
                    <input type="text" id="{{id}}" class="form-control validate" [attr.maxlength]="maxlength"
                           [(ngModel)]="model"
                           (ngModelChange)="update()"
                           formControlName="{{id}}"
                           [class.input-view]="readonly"
                           [readonly]="readonly"
                            currencyMask [options]="{ suffix: suffix, prefix: prefix, align: align, thousands: thousands, decimal: decimal, precision: precision }"
                           (keypress)="update()"
                           (keyup)="update()"
                           (change)="update()"
                           (keydown)="update()"
                           (input)="update()">
                    <div class="form-control-feedback" *ngIf="form.controls[id] && form.controls[id].touched && !form.controls[id].valid">
                      <i class="icon-cancel-circle2"></i>
                    </div>
                  </div>
                 
                  <ng-template [ngIf]="form.controls[id] && form.controls[id].errors">
                    <span class="help-block" *ngIf="form.controls[id].touched && !form.controls[id].valid && !form.controls[id].errors[id]">{{txt_default_erro}}</span>
                    <div *ngIf="!form.controls[id].valid">
                      <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                    </div>
                  </ng-template>
                </div>
              </div>`,
})

export class WidgetInputMoedaComponent {

  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  readonly: boolean = false;

  @Input()
  maxlength: number = 99;

  @Input()
  maxvalue: any = false;

  @Input()
  suffix: string = '';

  @Input()
  prefix: string = '';

  @Input()
  align: string = 'left';

  @Input()
  thousands: string = '.';

  @Input()
  decimal: string = ',';

  @Input()
  precision: number = 2;

  @Input()
  comIcone: any = false;

  constructor(
    private func: Funcoes
  ) {

  }

  update() {

    if(this.maxvalue !== false && this.maxvalue !== undefined && this.maxvalue !== null && this.maxvalue !== ''){
      let maxVal = parseFloat(this.maxvalue);
      if(!isNaN(maxVal) && parseFloat(this.model) > maxVal){
        this.model = maxVal;
        if(this.form && this.form.controls && this.id && this.form.controls[this.id]){
          this.form.controls[this.id].setValue(maxVal, { emitEvent: false });
        }
      }
    }

    this.modelChange.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-input-moeda.component.ts